import React from "react";
import "./LoadingSpinner.css";

const LoadingSpinner = ({
  text = "Loading...",
  subtitle = "Please wait while we prepare everything",
}) => (
  <div className="loading-overlay" role="status" aria-live="polite">
    <div className="loading-backdrop" />

    <div className="loading-spinner-container">
      {/* Spinner */}
      <div className="spinner-shell">
        <div className="spinner-ring" />
        <div className="spinner-glow" />
        <div className="spinner-center-dot" />
      </div>

      {/* Text */}
      <div className="loading-text-wrapper">
        <div className="loading-text">{text}</div>
        {subtitle && <div className="loading-subtitle">{subtitle}</div>}

        {/* Shimmer bar */}
        <div className="loading-progress-shell">
          <div className="loading-progress-bar" />
        </div>
      </div>
    </div>

    {/* Background particles */}
    <div className="loading-particles">
      <span className="particle p1" />
      <span className="particle p2" />
      <span className="particle p3" />
      <span className="particle p4" />
      <span className="particle p5" />
    </div>
  </div>
);

export default LoadingSpinner;
